<script lang="ts" setup></script>

<template>
  <footer>
    <div class="container">
      <p>有限会社 スマイルファミリー</p>
      <p>〒885-0001&emsp;宮崎県都城市金田町1835-1</p>
      <p>0120-14-5220</p>
      <p>smile-f97@celery.ocn.ne.jp</p>
      <p class="copyright">
        &copy; 有限会社スマイルファミリー all rights reserved.
      </p>
    </div>
  </footer>
</template>
<style scoped>
footer {
  border-top: 5px solid #8b4812;
  padding: 32px;
  background: linear-gradient(to right, #ffdcb6, #ffe2b6);
  color: #45230b;
  font-size: 16px;
  line-height: 1.6;
}
.container {
  max-width: 1000px;
  margin: 0 auto;
}
.copyright {
  margin-top: 8px;
}
@media (max-width: 800px) {
  footer {
    padding: 16px;
    font-size: 12px;
  }
}
</style>
